import React from 'react';

export const ALL_MARKETPLACES = 'shopify,etsy,walmart,amazon';

const OPTIONS = [
    { key: 'shopify', label: 'Shopify' },
    { key: 'etsy',    label: 'Etsy' },
    { key: 'walmart', label: 'Walmart' },
    { key: 'amazon',  label: 'Amazon' },
];

// Checkbox row bound to a CSV string ("shopify,etsy,walmart,amazon").
// value: string | null (null/undefined treated as all marketplaces)
const MarketplacesField = ({ value, onChange }) => {
    const selected = new Set(
        String(value != null ? value : ALL_MARKETPLACES)
            .split(',').map(s => s.trim()).filter(Boolean)
    );

    const toggle = (key) => {
        const next = new Set(selected);
        if (next.has(key)) next.delete(key); else next.add(key);
        onChange(OPTIONS.map(o => o.key).filter(k => next.has(k)).join(','));
    };

    return (
        <div className="kit-field" style={{ gridColumn: '1 / -1' }}>
            <span className="kit-field__label">Marketplaces</span>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', padding: '6px 2px' }}>
                {OPTIONS.map(o => (
                    <label key={o.key} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 13, cursor: 'pointer', userSelect: 'none' }}>
                        <input
                            type="checkbox"
                            checked={selected.has(o.key)}
                            onChange={() => toggle(o.key)}
                            style={{ accentColor: '#28a745', width: 15, height: 15, cursor: 'pointer' }}
                        />
                        {o.label}
                    </label>
                ))}
            </div>
        </div>
    );
};

export default MarketplacesField;
